import { FC, Fragment, useContext, useState } from "react";
import { EDocumentCategory, TWeightDocument } from "../../../content/types";
import {
  Box,
  Card,
  CardActions,
  CardContent,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { DocumentRow } from "./rows/document-row";
import { UserProgramContext } from "../../../context/user-program/user-program";
import { Dayjs } from "dayjs";
import { NextUploadModal } from "./next-upload-modal";
import { assertNonNullable } from "../../../utils/asserts";
import { ContainedButton } from "../../styled/contained-button";

type Props = {
  sectionTitle: string;
};

export type NewRowState = {
  file: File | null;
  weight: string | null;
  measurementDate: Dayjs | null;
};

export const WeightDocumentsWidget: FC<Props> = ({ sectionTitle }) => {
  const { program } = useContext(UserProgramContext);
  const [newUploadModalOpen, setNewUploadModalOpen] = useState(false);

  assertNonNullable(program);

  const documents = (program.sections
    .find((section) => section.title === sectionTitle)
    ?.documents?.filter(
      (document) => document.category === EDocumentCategory.WEIGHT_DATA
    ) || []) as Array<TWeightDocument>;

  return (
    <Fragment>
      <Card>
        <CardContent>
          <Box mb={3}>
            <Typography variant="h6" component="div">
              Gewichtsnachweise hochladen
            </Typography>
          </Box>
          <TableContainer component={Paper}>
            <Table aria-label="Weight data table">
              <TableHead>
                <TableRow>
                  <TableCell align="center">Gewichtsnachweis</TableCell>
                  <TableCell align="center">Daten</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {documents.map((document) => (
                  <DocumentRow key={document.createdOn} document={document} />
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
        <CardActions>
          <Box display="flex" width="100%" p={2}>
            <ContainedButton
              onClick={() => setNewUploadModalOpen(true)}
              muiType="normal"
              component="span"
            >
              Neue Datei Hochladen
            </ContainedButton>
          </Box>
        </CardActions>
      </Card>
      <NextUploadModal
        sectionTitle={sectionTitle}
        open={newUploadModalOpen}
        onClose={() => setNewUploadModalOpen(false)}
      />
    </Fragment>
  );
};
